import React, { useState } from "react";

export default function CTAButton({
                                    text = "Claim Your Bonus",
                                    href = "https://wagerstreet.net",
                                    primary = true,
                                  }) {
  const [ripples, setRipples] = useState([]);

  const createRipple = (event) => {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const newRipple = {
      x,
      y,
      id: Date.now(),
    };

    setRipples((prev) => [...prev, newRipple]);

    // Remove ripple after animation
    setTimeout(() => {
      setRipples((prev) =>
          prev.filter((ripple) => ripple.id !== newRipple.id)
      );
    }, 600);
  };

  return (
      <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={createRipple}
          className={
            primary
                ? "btn-primary btn-neumorphism btn-gradient-animated glow-green inline-block text-center relative overflow-hidden"
                : "btn-secondary inline-block text-center hover:glow-green relative overflow-hidden"
          }
      >
        {text}

        {ripples.map((ripple) => (
            <span
                key={ripple.id}
                className="ripple-effect"
                style={{
                  left: ripple.x,
                  top: ripple.y,
                }}
            />
        ))}
      </a>
  );
}
